import React, { useState } from 'react';
import { startCheckout } from '../lib/billing';

// ─── BillingCanceled ────────────────────────────────────────────────────────
//
// Landing target when the operator hits "back" on the Stripe Checkout
// hosted page. Two paths from here:
//   "Try again" → re-fires create-checkout-session for the monthly plan.
//   "Continue with limited access" → calls onContinue, App.js clears the
//     ?view= URL param. The paywall (or the rest of the app, if they're
//     still in trial) takes it from there.

export default function BillingCanceled({ onContinue }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function tryAgain() {
    if (busy) return;
    setBusy(true);
    setError('');
    const ok = await startCheckout('monthly', {
      onError: (r) => {
        setError((r && r.body && r.body.message) || 'Couldn\'t start checkout.');
      },
    });
    if (!ok) setBusy(false);
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="bg-white rounded-2xl border border-gray-200 p-8 w-full max-w-md text-center">
        <div style={{ fontSize: 28, marginBottom: 12 }}>👋</div>
        <div className="text-lg font-semibold text-gray-900 mb-2">Subscription not started</div>
        <div className="text-sm text-gray-500 leading-relaxed mb-6">
          You backed out of checkout. No charge was made. You can try again whenever you're ready.
        </div>
        {error && (
          <div className="text-xs text-red-500 bg-red-50 rounded-md px-3 py-2 mb-3">{error}</div>
        )}
        <button
          type="button"
          onClick={tryAgain}
          disabled={busy}
          className="w-full bg-blue-600 text-white rounded-lg py-2.5 text-sm font-semibold hover:bg-blue-700 disabled:opacity-50 mb-2"
        >
          {busy ? 'Starting…' : 'Try again'}
        </button>
        <button
          type="button"
          onClick={onContinue}
          className="w-full text-sm text-gray-500 hover:text-gray-700 hover:underline"
          style={{ background: 'transparent', border: 'none', padding: 8, cursor: 'pointer' }}
        >
          Continue with limited access
        </button>
      </div>
    </div>
  );
}
